import React, { Fragment } from "react";
import { Container } from "reactstrap";
import Breadcrumb from "../common/breadcrumb";
import FeedbackTable from "../common/FeedbackTable";

const Feedback = () => {
    return (
        <Fragment>
            <Breadcrumb title="Feedback" parent="Orders" />
            <Container fluid>
                <FeedbackTable />
            </Container>
        </Fragment>
    );
};

export default Feedback;
